import { Component, Input } from '@angular/core';
import { faCircle } from '@fortawesome/free-solid-svg-icons';
import { IAccount, IVisibleUsers } from '../../../store/models/account.model';

@Component({
  selector: 'app-view-representatives-status',
  templateUrl: './view-representatives-status.component.html',
  styleUrls: ['./view-representatives-status.component.scss'],
})
export class ViewRepresentativesStatusComponent {
  @Input() account: (IAccount | IVisibleUsers) | undefined;

  circle = faCircle;

  get isUser(): boolean {
    return this.account?.account_role === 'user';
  }

  get showNothing(): boolean {
    return !this.isUser;
  }

  get showOldStatus(): boolean {
    return !!this.isUser && !this.account?.vsm_group_id;
  }

  get showPurpleDot(): boolean {
    return (
      !!this.isUser &&
      !!this.account?.vsm_group_id &&
      !!this.account?.group_status
    );
  }

  get showDogIcon(): boolean {
    return (
      !!this.isUser &&
      !!this.account?.vsm_group_id &&
      !this.account?.group_status
    );
  }

  readonly purpleDotTooltip =
    '🟣 Purple dot\n\nDisplayed if the user has at least one contact group (other than "No Campaign") that:\nIs not assigned to any campaign, or\nIs assigned to a campaign that is pending (not running)';

  readonly dogIconTooltip =
    'Retreva logo\n\nDisplayed if all contact groups (other than "No Campaign") are assigned to campaigns and all assigned campaigns are currently running.';

  get oldStatusTooltip(): string {
    switch (this.account?.status) {
      case 'ok':
        return '🟢 Green dot\n\nDisplayed if none of the above conditions are met.';
      case 'warning':
        return '🟡 Yellow dot\n\nDisplayed if any of the following conditions are met:\n\n10 or more unread messages\nUnread messages that are 1 day old or older\n2 or more unknown messages';
      case 'danger':
        return '🔴 Red dot\n\nDisplayed if any of the following conditions are met:\n\nMore than 15 unread messages\nUnread messages older than 3 days\nMore than 3 unknown messages';
      default:
        return '';
    }
  }
}
